'use strict';

import { base, Component, PropTypes, update, sub, fromJS, toJS, mq, ReactChildren, Listener, redirect } from 'core';

import { Dialog } from 'material-ui';

import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';

import Card from 'c/card';

@base({ })
class ProductCard extends Component {

    render() {

        const { children, style = {}, w = 1, h = 1, ...props } = this.props;

        const { title, description, fullDescription, media, link, images: all_images, videos } = toJS(this._get());

        const locale = this._store().get('locale') || 'Pt';

        const images = Array.isArray(all_images) ? all_images.filter(img => img['media' + locale]) : undefined;

        const onTap = () =>
            this._store().edit('global', 'galery', fromJS({
                open: true, title, description, fullDescription, media, images, videos, actions: false
            }));

        const shouldOpenGalery = () => (
            !link &&
            (
                fullDescription
             || (images && images.length > 0)
             || (videos && videos.length > 0)

            ) && onTap.bind(this));

        return (
            <Card w={w} h={h} {...props}
                  onTouchTap={ shouldOpenGalery() } />
        );
    }
}

export default ProductCard



// WEBPACK FOOTER //
// ./ui/c/card/product.jsx